import React from 'react';
import PropTypes from 'prop-types';
import { Select, Checkbox, Divider } from 'antd';
import styled from 'styled-components';
import { normalizeString } from '../../../services/util/string';

const CheckboxContainer = styled.div`
  padding: 4px 8px 8px 8px;
  cursor: pointer;
`;

// Ignora acentos, caixa e espaços repetidos (ex.: "joao  silva" encontra "João Silva")
const normalizeSearch = (text) => normalizeString(text).replace(/\s+/g, ' ').trim();

const filterIgnoringAccents = (input, option) =>
  normalizeSearch(String(option?.children ?? '')).includes(normalizeSearch(input));

function MultiSelect({
  maxTagTextLength = 10,
  maxTagCount = 2,
  maxTagPlaceholder = (selectedValues) => `+${selectedValues.length} selecionados`,
  placeholder = undefined,
  areAllSelected = true,
  onChangeAllSelected,
  children = undefined,
  value = undefined,
  onChange,
  loading = false,
  disabled = false,
  height = '32px',
  onClose = undefined,
  tokenSeparators = [' ', ','],
  autoClearSearchValue = true,
  ignoreAccents = false,
}) {
  return (
    <Select
      onBlur={() => onClose && onClose()}
      style={{ height }}
      disabled={disabled}
      loading={loading}
      mode="multiple"
      showArrow
      value={value}
      onChange={onChange}
      maxTagTextLength={maxTagTextLength}
      maxTagCount={maxTagCount}
      maxTagPlaceholder={maxTagPlaceholder}
      placeholder={placeholder}
      tokenSeparators={tokenSeparators}
      autoClearSearchValue={autoClearSearchValue}
      optionFilterProp="children"
      filterOption={ignoreAccents ? filterIgnoringAccents : undefined}
      dropdownRender={(menu) => (
        <div>
          <CheckboxContainer onMouseDown={(e) => e.preventDefault()}>
            <Checkbox
              checked={areAllSelected}
              onChange={(e) => onChangeAllSelected(e.target.checked)}
            >
              Selecionar Todos
            </Checkbox>
          </CheckboxContainer>
          <Divider style={{ margin: '2px 0' }} />
          {menu}
        </div>
      )}
    >
      {children}
    </Select>
  );
}

MultiSelect.propTypes = {
  maxTagTextLength: PropTypes.number,
  maxTagCount: PropTypes.number,
  maxTagPlaceholder: PropTypes.func,
  placeholder: PropTypes.node,
  onChangeAllSelected: PropTypes.func.isRequired,
  areAllSelected: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  height: PropTypes.string,
  children: PropTypes.node,
  // eslint-disable-next-line react/forbid-prop-types
  value: PropTypes.any,
  onClose: PropTypes.func,
  tokenSeparators: PropTypes.arrayOf(PropTypes.string),
  autoClearSearchValue: PropTypes.bool,
  ignoreAccents: PropTypes.bool,
};

export default MultiSelect;
